import React, { useState, useEffect, useCallback } from 'react';
import { talukaAPI } from '../../services/api';

export default function TalukaNotices() {
  const [notices, setNotices] = useState([]);
  const [gps, setGps]         = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);
  const [page, setPage]       = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({ tenant_id: '', type: '', search: '' });

  const load = useCallback(async () => {
    try {
      setLoading(true); setError(null);
      const [nRes, gRes] = await Promise.all([
        talukaAPI.getNotices({ page, limit: 20, ...filters }),
        gps.length === 0 ? talukaAPI.getGrampanchayats() : Promise.resolve({ data: { grampanchayats: gps } })
      ]);
      const d = nRes.data?.notices || nRes.data?.data || nRes.data || {};
      setNotices(Array.isArray(d) ? d : []);
      setTotalPages(nRes.data?.pagination?.totalPages || Math.ceil((nRes.data?.pagination?.total || 1) / 20) || 1);
      if (gps.length === 0) setGps(gRes.data?.grampanchayats || gRes.data?.data || gRes.data || []);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load notices');
    } finally { setLoading(false); }
  }, [page, filters]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);
  const setF = (key, val) => { setFilters(f => ({ ...f, [key]: val })); setPage(1); };

  return (
    <div>
      <div className="tk-page-header">
        <h1>Notices &amp; Announcements</h1>
        <p>Public notices issued by Grampanchayats</p>
      </div>
      <div className="tk-filter-bar">
        <input placeholder="Search title…" value={filters.search} onChange={e => setF('search', e.target.value)} />
        <select value={filters.tenant_id} onChange={e => setF('tenant_id', e.target.value)}>
          <option value="">All GPs</option>
          {gps.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
        </select>
        <select value={filters.type} onChange={e => setF('type', e.target.value)}>
          <option value="">All Types</option>
          <option value="general">General</option>
          <option value="tender">Tender</option>
          <option value="meeting">Meeting</option>
          <option value="emergency">Emergency</option>
        </select>
      </div>
      {loading && <div style={{ textAlign: 'center', padding: 40 }}>Loading…</div>}
      {error   && <div style={{ textAlign: 'center', padding: 40, color: '#c62828' }}>{error}</div>}
      {!loading && !error && (
        <>
          <div className="tk-card">
            <div className="tk-table-wrap">
              <table className="tk-table">
                <thead>
                  <tr><th>Title</th><th>Type</th><th>Grampanchayat</th><th>Issued By</th><th>Published</th><th>Expires</th></tr>
                </thead>
                <tbody>
                  {notices.map((n, i) => (
                    <tr key={n.id || i}>
                      <td><strong>{n.title}</strong></td>
                      <td style={{ textTransform: 'capitalize' }}>{n.notice_type || n.type || '—'}</td>
                      <td>{n.gp_name || n.Tenant?.name || '—'}</td>
                      <td>{n.issued_by || '—'}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{n.published_at || n.createdAt ? new Date(n.published_at || n.createdAt).toLocaleDateString('en-IN') : '—'}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{n.expires_at ? new Date(n.expires_at).toLocaleDateString('en-IN') : '—'}</td>
                    </tr>
                  ))}
                  {notices.length === 0 && <tr><td colSpan={6} style={{ textAlign: 'center', padding: 24, color: '#aaa' }}>No notices found</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
          <div className="tk-pagination">
            <button onClick={() => setPage(p => p - 1)} disabled={page <= 1}>← Prev</button>
            <span style={{ fontSize: '0.85rem', color: '#555' }}>Page {page} of {totalPages}</span>
            <button onClick={() => setPage(p => p + 1)} disabled={page >= totalPages}>Next →</button>
          </div>
        </>
      )}
    </div>
  );
}
